<i18n>
{
  "fr": {
    "admin": {
      "homepage": {
        "title": "Section d'administration",
        "manage-obs-point": "Gérer les points d'observations",
        "manage-user": "Gérer les utilisateurs",
        "import-data": "Importer des chroniques"
      }
    }
  },
  "de": {

  }
}
</i18n>

<template>
  <div class="admin fullpage home">
    <div class="main-content">
      <h1>{{ $t('admin.homepage.title') }}</h1>
      <div class="admin-sections">
        <div v-if="hasUserRight" class="admin-section md-elevation-3">
          <router-link :to="{ name: 'admin-users' }">{{ $t('admin.homepage.manage-user') }}</router-link>
        </div>
        <div v-if="hasOperatorRight" class="admin-section md-elevation-3">
          <router-link :to="{ name: 'admin-observation-points' }">{{ $t('admin.homepage.manage-obs-point') }}</router-link>
        </div>
        <div v-if="hasOperatorRight" class="admin-section md-elevation-3">
          <router-link :to="{ name: 'admin-import-data' }">{{ $t('admin.homepage.import-data') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccessToken from '@/utils/accessToken'

export default {
  name: 'AdminHome',
  props: {
    title: {
      type: String,
      default: () => { return '!' }
    }
  },
  computed: {
    hasUserRight () {
      return AccessToken.get().hasRight('mgmt_users')
    },
    hasOperatorRight () {
      return AccessToken.get().hasRight('strates_operator')
    }
  }
}
</script>

<style lang="scss">
  .admin.home {
    h1 {
      text-align: center;
    }
    .admin-sections {
      display: flex;
      gap: 25px;
      .admin-section {
        width: 180px;
        min-height: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
    }
  }
</style>
